
export const PASS_PATTERN = /(?:[A-Za-z]\w*){4}(?:\d\w*){4}/;
export const NAME_PATTERN = /(?:[A-Za-z]\w*){4}/;
export const DATE_FORMAT = 'MM.DD.YYYY';

